"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.publicKeyv2 = exports.signSendChunkv2 = exports.serializePathv2 = void 0;
/** ******************************************************************************
 *  (c) 2018 - 2022 Zondax AG
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */
var commandsV1_1 = require("./commandsV1");
var common_1 = require("./common");
function serializePathv2(path) {
    if (!path || path.length !== 5) {
        throw new Error('Invalid path.');
    }
    var buf = Buffer.alloc(20);
    buf.writeUInt32LE(0x80000000 + path[0], 0);
    buf.writeUInt32LE(0x80000000 + path[1], 4);
    buf.writeUInt32LE(0x80000000 + path[2], 8);
    buf.writeUInt32LE(path[3], 12);
    buf.writeUInt32LE(path[4], 16);
    return buf;
}
exports.serializePathv2 = serializePathv2;
function signSendChunkv2(app, chunkIdx, chunkNum, chunk, txType) {
    if (txType === void 0) { txType = common_1.P2_VALUES.JSON; }
    return __awaiter(this, void 0, void 0, function () {
        var payloadType;
        return __generator(this, function (_a) {
            payloadType = common_1.PAYLOAD_TYPE.ADD;
            if (chunkIdx === 1) {
                payloadType = common_1.PAYLOAD_TYPE.INIT;
            }
            if (chunkIdx === chunkNum) {
                payloadType = common_1.PAYLOAD_TYPE.LAST;
            }
            return [2 /*return*/, (0, commandsV1_1.signSendChunkv1)(app, payloadType, 0, chunk, txType)];
        });
    });
}
exports.signSendChunkv2 = signSendChunkv2;
function publicKeyv2(app, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, app.transport.send(common_1.CLA, common_1.INS.GET_ADDR_SECP256K1, 0, 0, data, [common_1.ERROR_CODE.NoError]).then(function (response) {
                    var errorCodeData = response.slice(-2);
                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                    var compressedPk = Buffer.from(response.slice(0, 33));
                    return {
                        pk: 'OBSOLETE PROPERTY',
                        compressed_pk: compressedPk,
                        return_code: returnCode,
                        error_message: (0, common_1.errorCodeToString)(returnCode)
                    };
                }, common_1.processErrorResponse)];
        });
    });
}
exports.publicKeyv2 = publicKeyv2;
//# sourceMappingURL=commandsV2.js.map